import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LockKeyhole } from "lucide-react";
import client, { formatApiErrorDetail } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await client.post("/auth/login", { email, password });
      localStorage.setItem("oj_token", data.token);
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#050505] px-5" data-testid="admin-login-page">
      <div className="noise-overlay" aria-hidden="true" />
      <form
        onSubmit={submit}
        className="w-full max-w-sm border border-white/10 bg-[#0d0d0d] p-10"
        data-testid="admin-login-form"
      >
        <div className="flex justify-center">
          <img src="/assets/logo-gold.png" alt="Oro Jewels — Gioielli & Orologi" className="h-16 w-auto" />
        </div>
        <h1 className="mt-6 text-center font-serif text-2xl">Area riservata</h1>
        <p className="mt-2 text-center text-[10px] uppercase tracking-[0.3em] text-[#737373]">Gestione vetrina Oro Jewels</p>

        <label htmlFor="admin-email" className="mt-8 block text-[10px] uppercase tracking-[0.3em] text-[#A3A3A3]">Utente</label>
        <input
          id="admin-email"
          data-testid="admin-email-input"
          type="text"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="mt-2 w-full border border-white/15 bg-transparent px-4 py-3 text-sm"
          placeholder="Il tuo nome utente"
          autoComplete="username"
        />
        <label htmlFor="admin-password" className="mt-5 block text-[10px] uppercase tracking-[0.3em] text-[#A3A3A3]">Password</label>
        <input
          id="admin-password"
          data-testid="admin-password-input"
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-2 w-full border border-white/15 bg-transparent px-4 py-3 text-sm"
          placeholder="••••••••"
          autoComplete="current-password"
        />

        {error && (
          <p className="mt-4 border border-red-900/50 bg-red-950/30 px-4 py-3 text-sm text-red-300" data-testid="admin-login-error">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={loading}
          data-testid="admin-login-submit-button"
          className="mt-8 flex w-full items-center justify-center gap-2 bg-gold py-3.5 text-[11px] font-semibold uppercase tracking-[0.25em] text-black transition-colors hover:bg-gold-hover disabled:opacity-50"
        >
          <LockKeyhole size={14} />
          {loading ? "Accesso…" : "Accedi"}
        </button>
        <a href="/" data-testid="admin-login-back-link" className="mt-6 block text-center text-[10px] uppercase tracking-[0.3em] text-[#737373] transition-colors hover:text-gold">
          Torna al sito
        </a>
      </form>
    </main>
  );
}
